import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/other/sberbank/mobile/1.jpg'
import _imports_1 from '@/assets/other/sberbank/mobile/2.jpg'
import _imports_2 from '@/assets/other/sberbank/mobile/3.jpg'
import _imports_3 from '@/assets/other/sberbank/mobile/4.jpg'
import _imports_4 from '@/assets/other/sberbank/mobile/5.jpg'
import _imports_5 from '@/assets/other/sberbank/mobile/6.jpg'
import _imports_6 from '@/assets/other/sberbank/mobile/7.jpg'
import _imports_7 from '@/assets/other/sberbank/desktop/1.jpg'
import _imports_8 from '@/assets/other/sberbank/desktop/2.jpg'
import _imports_9 from '@/assets/other/sberbank/desktop/3.jpg'
import _imports_10 from '@/assets/other/sberbank/desktop/4.jpg'
import _imports_11 from '@/assets/other/sberbank/desktop/5.jpg'
import _imports_12 from '@/assets/other/sberbank/desktop/6.jpg'
import _imports_13 from '@/assets/other/sberbank/desktop/7.jpg'
import _imports_14 from '@/assets/other/sberbank/desktop/8.jpg'
import _imports_15 from '@/assets/other/sberbank/desktop/9.jpg'


const _hoisted_1 = /*#__PURE__*/_createTextVNode("Через телефон")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Через компьютер")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Запустите приложение \"Сбербанк онлайн\" на вашем устройстве. ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Откройте страницу \"Платежи\". Найдите и выберите пункт \"Платёж по реквизитам\". ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_1
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" В строку поиска введите номер ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "selection" }, "2801283403", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" , найдите и выберите пункт \"Комбинат школьного питания\". ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_2
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Введите ваш лицевой счет ")
const _hoisted_12 = { class: "selection" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" . Укажите карту для оплаты и нажмите на кнопку \"Продолжить\". ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_3
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Укажите в поле \"Сумма платежа\" нужную вам сумму и нажмите на кнопку \"Продолжить\". ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_4
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Проверьте правильность введенных данных с вашими. ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Лицевой счет: ")
const _hoisted_19 = { class: "selection" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" ФИО ребенка: ")
const _hoisted_21 = { class: "selection" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Если данные верны подтвердите платеж. (Обращаем внимание, что взимаемая комиссия равна 1% от суммы платежа.) ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_5
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" После успешного совершения платежа вы можете сохранить чек текущего платежа. ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_6
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Откройте сайт «Cбербанк онлайн» на своем компьютере. Обращайте внимание на подлинность сертификата сайта, и правильность адреса в строке браузера. ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mx-auto",
  src: _imports_7
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Перейдите на вкладку «Платежи» ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mb-4 mx-auto",
  src: _imports_8
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" И выберите «Платёж по реквизитам» ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mx-auto",
  src: _imports_9
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" В строку поиска введите номер ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "selection" }, "2801283403", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mb-4 mx-auto",
  src: _imports_10
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Найдите и выберите пункт \"Комбинат школьного питания\". ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mx-auto",
  src: _imports_11
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Введите ваш лицевой счет ")
const _hoisted_38 = { class: "selection" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" . и нажмите на кнопку \"Продолжить\". ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mx-auto",
  src: _imports_12
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Укажите в поле \"Сумма платежа\" нужную вам сумму и нажмите на кнопку \"Продолжить\". ")
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mx-auto",
  src: _imports_13
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Проверьте правильность введенных данных с вашими. ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Лицевой счет: ")
const _hoisted_45 = { class: "selection" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" ФИО ребенка: ")
const _hoisted_47 = { class: "selection" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Если данные верны подтвердите платеж. (Обращаем внимание, что взимаемая комиссия равна 1% от суммы платежа.) ")
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 mx-auto",
  src: _imports_14
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" После успешного совершения платежа вы можете сохранить чек текущего платежа. ")
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  class: "rounded-lg mt-4 max-h-[560px] mx-auto",
  src: _imports_15
}, null, -1)

import { computed, ref } from "vue";

import { useAsync } from "@/use/useAsync";
// import { useTokens } from "@/use/useTokens";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiAppbarBack from "@/plugins/ui/components/appbar/UiAppbarBack.vue";

import { useStore } from "@/use/useStore";
import AppSidebar from "@/components/AppSidebar.vue";
import UiTabs from "@/components/ui/UiTabs.vue";
import UiTab from "@/components/ui/UiTab.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiText from "@/plugins/ui/components/typography/UiText.vue";
import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Pay',
  setup(__props) {

const { currentUser } = useStore();

const tab = ref(0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, { title: "Пополнение счета" }, {
        left: _withCtx(() => [
          _createVNode(UiAppbarBack, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          })
        ]),
        _: 1
      })
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _createVNode(UiTabs, null, {
        default: _withCtx(() => [
          _createVNode(UiTab, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 0)),
            active: tab.value === 0
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["active"]),
          _createVNode(UiTab, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 1)),
            active: tab.value === 1
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        _: 1
      }),
      (tab.value === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "1. Запуск приложения" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "2. Выбор способа платежа" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "3. Поиск \"Комбинат школьного питания\"" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "4. Ввод лицевого счета" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(currentUser)?.score_id), 1),
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "5. Ввод суммы пополнения" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "6. Подтверждение платежа" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(UiText, { style: {"margin-top":"8px"} }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(currentUser)?.score_id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(UiText, { style: {"margin-top":"8px"} }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(currentUser)?.surname) + " " + _toDisplayString(_unref(currentUser)?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(UiCaption, { style: {"color":"#818c99","margin-top":"16px"} }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "7. Завершение платежа" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _hoisted_25
              ]),
              _: 1
            })
          ], 64))
        : (tab.value === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(UiGroup, null, {
                header: _withCtx(() => [
                  _createVNode(UiHeader, { title: "1. Переход на сайт «Cбербанк онлайн»" })
                ]),
                default: _withCtx(() => [
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }),
                  _hoisted_27
                ]),
                _: 1
              }),
              _createVNode(UiGroup, null, {
                header: _withCtx(() => [
                  _createVNode(UiHeader, { title: "2. Выбор способа платежа" })
                ]),
                default: _withCtx(() => [
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  _hoisted_29,
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  }),
                  _hoisted_31
                ]),
                _: 1
              }),
              _createVNode(UiGroup, null, {
                header: _withCtx(() => [
                  _createVNode(UiHeader, { title: "3. Поиск \"Комбинат школьного питания\"" })
                ]),
                default: _withCtx(() => [
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_32,
                      _hoisted_33
                    ]),
                    _: 1
                  }),
                  _hoisted_34,
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 1
                  }),
                  _hoisted_36
                ]),
                _: 1
              }),
              _createVNode(UiGroup, null, {
                header: _withCtx(() => [
                  _createVNode(UiHeader, { title: "4. Ввод лицевого счета" })
                ]),
                default: _withCtx(() => [
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_37,
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(currentUser)?.score_id), 1),
                      _hoisted_39
                    ]),
                    _: 1
                  }),
                  _hoisted_40
                ]),
                _: 1
              }),
              _createVNode(UiGroup, null, {
                header: _withCtx(() => [
                  _createVNode(UiHeader, { title: "5. Ввод суммы пополнения" })
                ]),
                default: _withCtx(() => [
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  }),
                  _hoisted_42
                ]),
                _: 1
              }),
              _createVNode(UiGroup, null, {
                header: _withCtx(() => [
                  _createVNode(UiHeader, { title: "6. Подтверждение платежа" })
                ]),
                default: _withCtx(() => [
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_43
                    ]),
                    _: 1
                  }),
                  _createVNode(UiText, { style: {"margin-top":"8px"} }, {
                    default: _withCtx(() => [
                      _hoisted_44,
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(currentUser)?.score_id), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(UiText, { style: {"margin-top":"8px"} }, {
                    default: _withCtx(() => [
                      _hoisted_46,
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(currentUser)?.surname) + " " + _toDisplayString(_unref(currentUser)?.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(UiCaption, { style: {"color":"#818c99","margin-top":"16px"} }, {
                    default: _withCtx(() => [
                      _hoisted_48
                    ]),
                    _: 1
                  }),
                  _hoisted_49
                ]),
                _: 1
              }),
              _createVNode(UiGroup, null, {
                header: _withCtx(() => [
                  _createVNode(UiHeader, { title: "7. Завершение платежа" })
                ]),
                default: _withCtx(() => [
                  _createVNode(UiText, null, {
                    default: _withCtx(() => [
                      _hoisted_50
                    ]),
                    _: 1
                  }),
                  _hoisted_51
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})